import React from 'react'

export function useCopyToClipboard (duration: number = 3000) {
  const [isCopied, setIsCopied] = React.useState(false)
  let timeoutId: ReturnType<typeof setTimeout> | null = null

  const copyToClipboard = React.useCallback((text: string) => {
    navigator.clipboard.writeText(text)
    setIsCopied(true)

    if (timeoutId !== null) {
      clearTimeout(timeoutId)
      timeoutId = null
    }

    timeoutId = setTimeout(() => {
      setIsCopied(false)
      timeoutId = null
    }, duration)
  }, [duration])

  return { isCopied, copyToClipboard }
}
